<template>
 

  <router-view/>

  <a class="float whatsapp-icone" target="_blank" href="https://api.whatsapp.com/send?phone=5544991455935" >
    <i class="fa fa-whatsapp my-float "></i>
  </a>
  
</template>

<script>

  const userLogged = (localStorage.getItem('token') == null) ? false : true
  
  export default {
    name: 'App',
    data() {
      return {
        userLogged,
        userName: localStorage.getItem('nomeUsuario'),
        token: localStorage.getItem('token'),
        logoEmpresa : "https://files.vexsoft.com.br/" + localStorage.getItem('token') + "/logo.png" 
      }
    },

    created: function (){ 
      if(!userLogged){
        this.$router.push('/Login')
      }
      else{
        this.$router.push('/Home')
      }
    },  
  }

</script>


<style>

  .float{
    position:fixed;
    width:60px;
    height:60px;
    bottom:60px;
    right:60px;
    background-color:#25d366;
    color:#FFF;
    border-radius:50px;
    text-align:center;
    font-size:30px;
    box-shadow: 2px 2px 3px #999;
    z-index:100;
    animation: pulse 2s infinite;
}

  .whatsapp-icone:hover {
    color: #fff!important
  }

  .my-float{
    margin-top:16px;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(90, 162, 78, 0);
    }

    50% {
      transform: scale(1.2);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }


</style>
